import { GTMPushEvent } from "helpers/google-tag-manager";
import convertToUrl from "helpers/convert-to-url";
import { slugify } from "src/utils/string";

let debounceTimer;
const listingSentItems = [];
let listingVirtualState = [];

const debounce = (callback, time) => {
  window.clearTimeout(debounceTimer);
  debounceTimer = window.setTimeout(callback, time);
};

const prepareData = ({ listings }) => {
  const items = document.querySelectorAll("[data-index]");
  debounce(() => {
    items.forEach((item) => {
      const itemId = item.getAttribute("data-id");
      const itemRect = item.getBoundingClientRect();
      if (itemRect.top - window.innerHeight < 0 && !listingSentItems.some((item) => item.includes(`${itemId}`))) {
        listingVirtualState.push(itemId);
      }
    });
    listingSentItems.push(listingVirtualState);

    if (listingVirtualState.length > 0) {
      const selectedListings = [];
      listings.forEach((listing) => {
        if (listingVirtualState.includes(`${listing.id}`)) {
          const selectedElement = document.querySelector(`[data-id="${listing.id}"]`);
          const position = selectedElement?.getAttribute("data-index");
          selectedListings.push({ ...listing, position: Number(position) });
        }
      });

      similarListingsViewedGtmEvent(selectedListings);
    }
    listingVirtualState = [];
  }, 250);
};

export const getPriceForProjects = (item) => {
  const price = item?.price || item?.priceDetail || item;
  let data = "0.00";
  if (price?.priceVisibility === "ASK") {
    data = "0.00";
  } else if (price?.priceVisibility === "STARTCOUNT") {
    data = `${price?.startPrice?.toFixed(2)}`;
  } else if (price?.priceVisibility === "RANGE") {
    if (price?.minPrice) {
      data = `${price?.minPrice?.toFixed(2)} - ${price?.maxPrice?.toFixed(2)}`;
    } else if (price?.min) {
      data = `${Number(price?.min)?.toFixed(2)} - ${Number(price?.max)?.toFixed(2)}`;
    }
  }
  return data;
};

const generateGa4EcommerceSimilarListingItem = (params) => {
  const { listing, index } = params;
  const getSearchId = JSON.parse(localStorage.getItem("EjGtmId"));
  const searchId = getSearchId.listingsearch;

  const result = [
    {
      search_id: searchId,
      item_price: listing?.priceDetail?.price?.toFixed(2) || "0.00",
      item_id: `${listing.id}`,
      item_name: convertToUrl(listing?.title),
      currency: listing?.priceDetail?.currency,
      discount: 0.0,
      index,
      item_brand: "ilan",
      item_category: slugify(listing.categoryTypeName) || undefined,
      item_category2: slugify(listing.estateTypeName) || undefined,
      item_category3: slugify(listing.location?.city?.name) || undefined,
      item_category4: slugify(listing.location?.district?.name) || undefined,
      item_category5: slugify(listing.location?.town?.name) || undefined,
      item_list_id: "A7b9K1m4Qz8xL2wP0vN5rY6cJ3hD7tF1sV8u",
      item_list_name: "ilan-listeleme/benzer-ilanlar",
      item_variant: slugify(listing?.tradeTypeName),
      location_id: listing.location?.city?.id,
      price: 0.0,
      quantity: 1,
    },
  ];
  return result;
};

export const generateGa4EcommerceRelatedProjectItem = (params) => {
  const { item, index, searchId, listName, affiliation } = params;
  const { name, title } = item || {};
  const location = item?.location || item?.locationInfo || {};
  const currency = item.priceDetail?.currency || item?.price?.currency || item?.currency?.symbol || item?.currency;
  const result = {
    proje_id: item.id,
    search_id: searchId,
    item_price: getPriceForProjects(item),
    item_id: item.id,
    item_name: name ? slugify(name) : slugify(title),
    currency,
    discount: 0.0,
    index,
    item_brand: "proje",
    item_category: Array.isArray(item.category) ? item.category[item.category.length - 1]?.slug : item.category?.slug,
    item_category2: item.estateType?.slug,
    item_category3: slugify(location?.cityName),
    item_category4: slugify(location?.districtName),
    item_category5: slugify(location?.townName) || undefined,
    item_list_id: "8sJZ2enQlse3XaLtCbPDDrGTwwaKbsjt",
    item_list_name: listName,
    item_variant: slugify(item.tradeType?.name) || item.tradeType?.slug,
    location_id: location?.cityId || location?.city?.id,
    price: 0.0,
    quantity: 1,
  };

  if (affiliation) {
    result.affiliation = affiliation;
  }

  return result;
};

const similarListingsViewedGtmEvent = (params) => {
  params.forEach((listing) => {
    GTMPushEvent({ ecommerce: null });
    GTMPushEvent({
      event: "view_item_list",
      ecommerce: {
        items: generateGa4EcommerceSimilarListingItem({
          listing,
          listName: "benzer-ilanlar",
          index: listing.position,
        }),
      },
    });
  });
};

const similarListingSearchScrollGTMEvents = ({ listings }) => {
  const items = document.querySelectorAll("[data-index]");
  const prepareDataParams = { listings };

  const scrollHandler = () => {
    prepareData(prepareDataParams);
  };

  const loadHandler = () => {
    prepareData(prepareDataParams);
  };

  if (items.length > 0) {
    window.addEventListener("scroll", scrollHandler, false);
    window.addEventListener("load", loadHandler);
  }

  return () => {
    window.removeEventListener("scroll", scrollHandler, false);
    window.removeEventListener("load", loadHandler);
  };
};

export default similarListingSearchScrollGTMEvents;
